module.exports = __webpack_public_path__ + "media/images/press_kit/shoretime_light/email/banner-4a35bbf77996dec09c6516bb411233a4.jpg";